// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"26":"beae8c7c","94":"a6d974f2","310":"f5ba514c","423":"ed088183","626":"5ba27205","732":"7e58b3a3","767":"3654c535","835":"ca629d4f","911":"24648b24"}[chunkId] + ".chunk.js";
};